import React from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import { DashboardLayout } from './layouts/DashboardLayout';
import { Dashboard } from './pages/Dashboard';
import { ExceptionsQueue } from './pages/ExceptionsQueue';
import { Claims } from './pages/Claims';
import { SoldClaims } from './pages/SoldClaims';
import { Salvagers } from './pages/Salvagers';
import { SalvagerClaims } from './pages/SalvagerClaims';
import { Leaderboard } from './pages/Leaderboard';
import { Reports } from './pages/Reports';
import { Auth } from './pages/Auth';
import { Landing } from './pages/Landing';
import { useAuth } from './context/AuthContext';
import SafeIcon from './common/SafeIcon';
import { FiLoader } from 'react-icons/fi';
import './index.css';

// Placeholder components
const Settings = () => <div className="p-8"><h1 className="text-2xl font-bold">Settings</h1></div>;

function App() {
  const { user, loading } = useAuth();

  // Show loading spinner while checking session
  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <SafeIcon icon={FiLoader} className="animate-spin text-brand text-4xl" />
      </div>
    );
  }

  return (
    <HashRouter>
      <Routes>
        {/* Public Routes (Only visible when NOT logged in) */}
        {!user ? (
          <>
            <Route path="/" element={<Landing />} />
            <Route path="/auth" element={<Auth />} />
            {/* Catch all unauthenticated routes and redirect to landing */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </>
        ) : (
          /* Authenticated Routes (Only visible when logged in) */
          <Route path="/" element={<DashboardLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="claims" element={<Claims />} />
            <Route path="my-claims" element={<SalvagerClaims />} />
            <Route path="salvagers" element={<Salvagers />} />
            <Route path="exceptions" element={<ExceptionsQueue />} />
            <Route path="sold" element={<SoldClaims />} />
            <Route path="leaderboard" element={<Leaderboard />} />
            <Route path="reports" element={<Reports />} />
            <Route path="settings" element={<Settings />} />
            {/* Catch all authenticated routes and redirect to dashboard */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        )}
      </Routes>
    </HashRouter>
  );
}

export default App;